import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { BoldBodyText, BoldFormTitle, BoldSpan } from '../styles/Text'
import { FlexColumn, FlexEndContainer, PaddedForm, StyledDialog, StyledDialogContent } from '../styles/Containers'
import Button, { SecondaryButton } from '../common/Button'
import { ErrorMessage, SuccessMessage } from '../common/UserMessage'
import axios from '../../dataClient/dataClient'
import { billTypeMap } from '../../util/billingConsts'

function CancelBillPopUp({ billId, billType, secondaryId, amount, open = false, onClose = () => {}, onSuccess = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)

  const billTypeLabel = billTypeMap[billType] || billType

  useEffect(() => {
    if (!open) return

    setError(false)
    setIsCompleted(false)
    setIsLoading(false)
  }, [open])

  function onSubmit(e) {
    e.preventDefault()
    setIsLoading(true)
    setError(false)

    axios
      .post(`/bill/${billId}/cancel`)
      .then(() => {
        setIsCompleted(true)
        onSuccess()
      })
      .catch(err => {
        console.error(`Failed to cancel ${billTypeLabel.toLowerCase()}`, err)
        setError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <StyledDialog fullWidth open={open} onClose={onClose} keepMounted={false}>
      <StyledDialogContent>
        <PaddedForm onSubmit={onSubmit}>
          <FlexColumn gap="20px">
            <BoldFormTitle>Cancel {billTypeLabel}</BoldFormTitle>

            {isCompleted ? (
              <FlexColumn gap="20px">
                <SuccessMessage>
                  {billTypeLabel} <BoldSpan>{secondaryId}</BoldSpan> successfully cancelled.
                </SuccessMessage>
              </FlexColumn>
            ) : (
              <FlexColumn gap="20px">
                <BoldBodyText>
                  Are you sure you want to cancel {billTypeLabel.toLowerCase()} <BoldSpan>{secondaryId}</BoldSpan> for{' '}
                  <BoldSpan>${amount.toFixed(2)}</BoldSpan>?
                </BoldBodyText>
                {error && <ErrorMessage>There was an error cancelling the {billTypeLabel.toLowerCase()}. Please try again.</ErrorMessage>}
              </FlexColumn>
            )}

            <FlexEndContainer>
              {isCompleted ? (
                <SecondaryButton type="button" onClick={onClose}>
                  Close
                </SecondaryButton>
              ) : (
                <>
                  <SecondaryButton type="button" onClick={onClose} disabled={isLoading}>
                    Go back
                  </SecondaryButton>
                  <Button type="submit" loading={isLoading}>
                    Confirm
                  </Button>
                </>
              )}
            </FlexEndContainer>
          </FlexColumn>
        </PaddedForm>
      </StyledDialogContent>
    </StyledDialog>
  )
}

CancelBillPopUp.propTypes = {
  billId: PropTypes.string.isRequired,
  billType: PropTypes.oneOf(['APPLICATION_FEE', 'FEE_ESTIMATE', 'INVOICE']).isRequired,
  secondaryId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
}

export default CancelBillPopUp
